import { CloseOutlineIc, LogoWhatsappOutlineIc } from '@dsch/dd-icons';

import { Button } from 'components/Toolkit/Button';
import { StickyFooter } from 'components/Toolkit/StickyFooter/StickyFooter';
import { Columns } from 'components/Toolkit/Columns/Columns';
import { RevealPhoneNumber } from 'components/PageWrappers/SharedComponents/RevealPhoneNumber/RevealPhoneNumber';
import { RevealDealerEnquiryModal } from 'components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal';
import { Mobile } from 'components/Support/Mobile/Mobile';
import { Loading } from 'components/Toolkit/Loading/Loading';

import { theme } from 'helpers/Theme';
import {
  StickyContactSeller,
  DialogHeaderText,
  DialogBody,
  DialogHeader,
  SButtonWhatsApp,
  SBottomSheetInner,
  SBottomSheet,
  Close,
  OverlayStyle,
} from 'components/PageWrappers/AdDetails/components/ContactDealership/ContactDealership.styled';

import { useContactDealership } from 'components/PageWrappers/AdDetails/components/ContactDealership/ContactDealership.hook';
import type { ContactDealershipProps } from 'components/PageWrappers/AdDetails/components/ContactDealership/ContactDealership.typed';

import { CDN_STATIC_ASSETS } from 'utils';

const ContactDealership = (props: ContactDealershipProps) => {
  const {
    adId,
    phoneResponse,
    dealer,
    campaignId,
    sellerType,
    emailResponse,
    sectionName,
    handleReveal,
  } = props;

  const {
    onWhatsAppButtonClick,
    isContactSellerModalOpen,
    openContactSellerModal,
    closeContactSellerModal,
    isLoading,
  } = useContactDealership({ adId });

  return (
    <Mobile>
      <StickyContactSeller>
        <StickyFooter data-testid="contact-seller-sticky-footer">
          <Columns>
            <Button
              data-testid="contact-seller-button"
              onClick={openContactSellerModal}
            >
              Contact Dealership
            </Button>
          </Columns>
        </StickyFooter>
      </StickyContactSeller>

      <OverlayStyle />
      <SBottomSheet
        height="234px"
        isOpen={isContactSellerModalOpen}
        className="bottom-sheet"
        overlayClassName="bottom-sheet-overlay"
        onRequestClose={closeContactSellerModal}
        closeTimeoutMS={200}
      >
        <SBottomSheetInner>
          <DialogHeader>
            <DialogHeaderText>Contact Dealership</DialogHeaderText>
            <Close onClick={closeContactSellerModal} data-testid="modal-close">
              <CloseOutlineIc width="16" height="16" />
            </Close>
          </DialogHeader>
          <DialogBody>
            {phoneResponse && (
              <RevealPhoneNumber
                id={adId}
                showNumberTextVariant={false}
                trackingId="reveal-number-gallery"
                clickSource="gallery"
                isPrimaryButton={Boolean(!dealer && !emailResponse)}
                campaignId={campaignId}
                sectionName={sectionName}
                sellerType={sellerType}
              />
            )}

            {dealer && emailResponse && (
              <RevealDealerEnquiryModal
                adId={adId}
                id="dealer-enquiry-btn-gallery"
                text="Send Email"
                ofType="SECONDARY"
                handleReveal={handleReveal}
              />
            )}

            <SButtonWhatsApp ofType="SECONDARY" onClick={onWhatsAppButtonClick}>
              {isLoading ? (
                <Loading color="DARK" cdnUrl={CDN_STATIC_ASSETS} />
              ) : (
                <>
                  <LogoWhatsappOutlineIc
                    color={theme.colors.GREEN}
                    width={24}
                    height={24}
                  />
                  &nbsp;Chat on WhatsApp
                </>
              )}
            </SButtonWhatsApp>
          </DialogBody>
        </SBottomSheetInner>
      </SBottomSheet>
    </Mobile>
  );
};

export { ContactDealership };
